import extend from 'mdui.jq/es/functions/extend';
import stateDefault from '~/components/users-dialog/stateDefault';
export default extend({}, stateDefault);